import { useEffect, useState } from "react";
import { Card, ContainerScreenGeneral, Modal, MuniSpinner2, Table } from "../../../components";
import { tableData } from "./tableData";
import { useGeneralAppStore } from "../../../store/generalAppStore";
import ModalMotivo from "../../../views/modals/ModalMotivo";
import ModalActaNotificar from "../../../views/modals/ModalActaNotificar";
import ModalNotificar from "../../../views/modals/ModalNotificar";
import { useNotificadoresStore } from "../../../store/notificadoresStore";
import { useFilterActasNotificador } from "../../../hooks/useFilterActasNotificador";
import { getActas, getMotivosReporte } from "../../../handlers/notificadores.handler";
import Table2 from "../../../components/Table2";
import FilterBarNotificador from "../components/FilterBarNotificador";
import { useWindowSize } from "../../../hooks";

const ActasNoNotificadas = () => {
    const [row, setRow] = useState(false);
    const [refetch, setRefetch] = useState();
    const { handlerModal } = useGeneralAppStore();
    const { width } = useWindowSize();


    //? ESTADOS GLOBALES
    const { loads, modals } = useGeneralAppStore();
    const { setActas, actas, motivos, filterFields, order, buscar, paginateCfg, filterEstado } = useNotificadoresStore();

    const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 100 });

    //~ HOOKS
    // const filterActas = useFilterActasNotificador();

    useEffect(() => {
        if (!actas) getActas(
            {
                // "estado_id": filterEstado,
                "estado_id": "no-notificadas",
                "buscar": buscar,
                "order": order,
                "per_page": paginationModel.pageSize
            },
            paginationModel
        )

        if (!motivos) getMotivosReporte()

        return () => {
            setActas(null);
        }
    }, []);


    const handlePaginationChange = (model) => {
        setPaginationModel(model);
    };



    useEffect(() => {
        if (refetch) {
            getActas(
                {
                    // "estado_id": filterEstado,
                    "estado_id": "no-notificadas",
                    "buscar": buscar,
                    "order": order,
                    "per_page": paginationModel.pageSize
                }
            ),
                paginationModel
        }
        setRefetch(false)
    }, [refetch])

    useEffect(() => {
        if (actas) {
            const timer = setTimeout(() => {
                getActas(
                    {
                        // "estado_id": filterEstado,
                        "estado_id": "no-notificadas",
                        "buscar": buscar,
                        "order": order,
                        "per_page": paginationModel.pageSize
                    },
                    paginationModel
                )
            }, 750)
            return () => clearTimeout(timer);
        }
    }, [buscar, order, paginationModel, filterEstado])

    return (
        <>
            <ContainerScreenGeneral titulo={"Actas sin entregar"} linkBack={'/notificador'} size={"lg"}>
                <section style={{ height: "60vh" }}>

                    {(loads.includes('load_actas_notificador') && !actas) ? (
                        <div className="d-flex w-100 h-100 justify-content-center align-items-center ">
                            <MuniSpinner2 />
                        </div>
                    ) : (
                        <>
                            {actas ?
                                <>
                                    {/* <FilterBarNotificador filterActas={filterActas} excel="front" /> */}
                                    {/* <Table2
                  height={"400px"}
                  data={tableData(actas.data, setRow)}
                  name="actas"
                /> */}

                                    <FilterBarNotificador filterActas={actas?.data} excel="back" estadoCsv={"no-notificadas"} />
                                    <div className="mt-4">
                                        <Table
                                            height={600}
                                            loading={loads.includes('load_actas_notificador')}
                                            data={tableData(actas?.data, setRow, width)}

                                            paginationMode="server"
                                            paginationModel={paginationModel}
                                            onPaginationModelChange={handlePaginationChange}
                                            rowCount={paginateCfg?.total || 0}

                                            rowClick={(params) => {
                                                setRow(params.row);
                                                handlerModal({ modal: true, modalName: "modal_notificar" });
                                            }}
                                        />
                                    </div>
                                    {modals.includes('modal_notificar') && <ModalActaNotificar titleModal={`Acta - ${row?.numero_acta}`} row={row} />}
                                    {modals.includes('modal_motivo') && <ModalMotivo titleModal={`Motivo de no notificar`} row={row} setRefetch={setRefetch} />}
                                    {modals.includes('notificar') && <ModalNotificar titleModal={`Notificar acta`} row={row} setRefetch={setRefetch} />}
                                </>

                                : (
                                    <p>Sin datos para mostrar.</p>
                                )}
                        </>
                    )}
                </section>
            </ContainerScreenGeneral >
        </>
    );
};
export default ActasNoNotificadas;
